import {useTranslation} from 'hooks/translations/useCustomTranslation';
import React, {useContext} from 'react';

import Markdown from 'components/basic-components/MarkdownContent';
import {withErrorBoundary} from 'components/error/ErrorBoundary';

import {CDWPropsContext} from "context/cdwPropsContext";
import Box from '../Box';
import {CustomIcon} from '../CustomIcon/CustomIcon';
import InfoPopup from '../InfoPopup';
import Typography from '../Typography';
import styles from './CDWPopup.module.scss';
import {Group} from "lib/api/backend.schemas";

interface CDWPopupProps {
  group?: Group;
  typoComponent?: React.ReactNode;
  cdwRelationOverride?: string;
  iconSize?: string;
}

const CDWPopup = ({group, typoComponent, cdwRelationOverride, iconSize}: CDWPopupProps) => {
  const cdwProps = useContext(CDWPropsContext);
  const {t} = useTranslation('common');
  const cdwRelation = group?.cdwRelation ? group?.cdwRelation : 'CDW_DEFAULT';

  return (
    <InfoPopup
      trigger={
        <Box className={styles.triggerWrapper}>
          {typoComponent || <Typography className={styles.text}>{t('cdw')}</Typography>}
          <CustomIcon name="info" className={styles.icon} height={iconSize || '24px'} width={iconSize || '24px'} />
        </Box>
      }
    >
      <Markdown className={styles.markdown} content={cdwProps?.CDW[cdwRelationOverride || cdwRelation]?.markdown || cdwProps?.CDW['CDW_DEFAULT']?.markdown} />
    </InfoPopup>
  );
};

export default withErrorBoundary(CDWPopup, 'CDWPopup');
